import { render, staticRenderFns } from "./baseInput.vue?vue&type=template&id=97afb3ae&scoped=true"
import script from "./baseInput.vue?vue&type=script&lang=js"
export * from "./baseInput.vue?vue&type=script&lang=js"
import style0 from "./baseInput.vue?vue&type=style&index=0&id=97afb3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97afb3ae",
  null
  
)

export default component.exports